export const SET_STEP = 'SET_STEP';
export const SET_STEP_TRIGGER = 'SET_STEP_TRIGGER';
